import { render, staticRenderFns } from "./epfoForm.vue?vue&type=template&id=32eb3e1c&"
import script from "./epfoForm.vue?vue&type=script&lang=js&"
export * from "./epfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports